import React from "react";
import { Link } from "@quintype/components";
import { object, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import { staticTexts } from "../../utils/Translate";

import "./fileAttachment.m.css";

const FileAttachment = ({ element, lang }) => (
  <div styleName="file-attachment-wrapper">
    <div styleName="file-name">{element["file-name"]}</div>
    <div styleName="download-link">
      <Link aria-label={staticTexts(lang).download} href={element.url}>
        {staticTexts(lang).download}
      </Link>
    </div>
  </div>
);

FileAttachment.propTypes = {
  element: object,
  lang: string,
};

const mapStateToProps = (state) => ({
  lang: get(state, ["qt", "config", "publisher-attributes", "lang"], ""),
});

export default connect(mapStateToProps)(FileAttachment);
